import { ReactNode, useState, useRef } from 'react'

import { IconText } from '@hhgtech/hhg-components'
import MinusIcon from 'public/svg/minus.svg'
import PlusIcon from 'public/svg/plus.svg'
import { useIntl } from 'react-intl'

import {
  StyledSources,
  StyledHeading,
  StyledExpandableContainer,
} from './index.styled'

export type Source = string

export type Props = {
  size?: 'lg' | 'md' | 'sm'
  className?: string
  sources: Source
  heading?: ReactNode
  isMobile?: boolean
}

const Sources = ({
  className,
  size = 'md',
  sources = '',
  heading,
  isMobile,
}: Props) => {
  const { formatMessage: f } = useIntl()
  const [expand, setExpand] = useState(false)
  const sourcesRef = useRef<HTMLDivElement>(null)

  return (
    <StyledSources className={className} data-size={size}>
      <StyledHeading
        onClick={() => {
          setExpand((e) => !e)
        }}
      >
        <IconText
          size={size}
          iconPosition="left"
          icon={
            expand ? (
              <MinusIcon
                className="source-icon"
                width={isMobile ? '16' : '24'}
              />
            ) : (
              <PlusIcon
                className="source-icon"
                width={isMobile ? '16' : '24'}
              />
            )
          }
          className="icon-text"
        >
          <span>{heading || f({ id: 'articlePage.sourceCount' })}</span>
        </IconText>
      </StyledHeading>
      <StyledExpandableContainer
        data-expand={expand}
        style={
          expand
            ? {
                height: sourcesRef.current?.clientHeight,
              }
            : {}
        }
      >
        <div
          className={'source-wrapper'}
          ref={sourcesRef}
          dangerouslySetInnerHTML={{ __html: sources }}
        />
      </StyledExpandableContainer>
    </StyledSources>
  )
}

export { Sources }
